/**
 * collapse.js.
 *
 * Toggle behavior for the collapse component
 */
(function($) {

	// $collapse = $('.collapse');
	
	$('a.collapse-toggle, .wp-block-button.collapse-toggle a').click(function(event){
		event.preventDefault();
		$this = $(this);
		$el_href = $this.attr('href');

		$target_el = $('.collapse' + $el_href + ',[class^="collapse-"][id="' + $el_href + '"]');

		if( $target_el.hasClass('show') )
			$target_el.slideUp().removeClass('show');
		else 
			$target_el.slideDown().addClass('show');

		if( $this.hasClass('active') ) {
			$this_text = $this.data('text');
			$this.removeClass('active').text($this_text);
		} else { 
			$this_text = $this.text();
			$this.addClass('active').data('text', $this_text).text('Close');
		}
	});

})(jQuery);